/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../resources/enums';
import '../../resources/error';
import '../resources/datatypes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "ListCatalogRequest": {
                        "fields": {
                          "cursor": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "types": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "includeCounts": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "catalogVersion": {
                            "type": "int64",
                            "id": 4,
                            "rule": "optional"
                          },
                          "limit": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional"
                          },
                          "includeNestedObjects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.InlineTypes",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": "INLINE_ALL"
                            }
                          },
                          "includeInventory": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          }
                        }
                      },
                      "ListCatalogResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "objects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.ListCatalogRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.ListCatalogResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListCatalogRequest @ squareup/connect/v2/catalog/interfaces/list-catalog.proto at 19:1
 */
export const ListCatalogRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.ListCatalogRequest');
fixType(ListCatalogRequest);
Builder.createAndAttachToType(ListCatalogRequest);
/**
 * SOURCE ListCatalogResponse @ squareup/connect/v2/catalog/interfaces/list-catalog.proto at 103:1
 */
export const ListCatalogResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.ListCatalogResponse');
fixType(ListCatalogResponse);
Builder.createAndAttachToType(ListCatalogResponse);